<div class="modal-container error-list-modal">
  <div class="modal-content">
    <div class="modal-header">
      <h4
        class="modal-title"
        id="modal-basic-title"
        [innerHtml]="'csvImport.saveCartErrorModal.title' | cxTranslate"
      ></h4>
      <button type="button" class="close" aria-label="Close" (click)="closeModal('Cross click')">
        <mat-icon svgIcon="x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      @if (isDesktop$ | async) {
      <app-table [columns]="columns" [dataSource]="dataSource" [paginator]="null"></app-table>
      } @else {
      <div class="error-list-table-container mobile">
        @if (errorListData) {
        <div class="error-list-column">
          @for (error of errorListData; track error) {
          <div class="error-data">
            <div class="error-body">
              <h5 class="error-title mb-0">{{ columns[0].displayName }}</h5>
              <p class="error-value">{{ error.column }}</p>
              <h5 class="error-title mb-0">{{ columns[1].displayName }}</h5>
              <p class="error-value">{{ error.row }}</p>
              <h5 class="error-title mb-0">{{ columns[2].displayName }}</h5>
              <p class="error-value mb-0">{{ error.details }}</p>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark primary-btn close-btn"
        [innerHtml]="'csvImport.saveCartErrorModal.close' | cxTranslate"
        (click)="closeModal('Cross click')"
      ></button>
    </div>
  </div>
</div>
